import React from 'react';
import './services.css'
import ServiceBox from '../../components/homeComponent/ServiceBox';
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { Accordion } from 'react-bootstrap';
import airIcon from '../../assets/images/services/air-freight-icon.svg';
import oceanIcon from '../../assets/images/services/ocean-freight-icon.svg';
import pacakgeIcon from '../../assets/images/services/package-icon.svg';
import landIcon from '../../assets/images/services/land-express-icon.svg';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet-async";


const Services = () => {

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const location = useLocation();
    console.log("locationService", location?.pathname);

    return (
        <>
            <Helmet>
                <title>AI-driven Logistics Services | Last Mile Delivery – iLine</title>
                <meta name="description" content="Explore iLine Logistics range of services, including last-mile delivery, parcel shipping, regional freight, AI-driven logistics optimization, seamless onboarding, and collaborative fleet partnerships. As a reliable logistics partner, we deliver efficient and customized solutions to meet your unique needs." />
                <link rel="canonical" href={`https://iline.ai${location.pathname}`} />
            </Helmet>
            <Header />
            <section className='ourServices'>
                <div className="container">
                    <div className="osLeft">
                        <h2>Our Services</h2>
                    </div>
                    <div className="osRight">
                        <p>
                            Iline.ai is at the forefront of transforming logistics through cutting-edge electric vehicle (EV) technology and AI-driven innovations. By offering tailored solutions for both customers and fleet owners, Iline.ai bridges the gap between eco-conscious operations and efficient.
                        </p>
                    </div>
                </div>
            </section>

            {/* <section className='ServiceBanner'>
                <img src={require('../../assets/images/services/service-banner.webp')} />
            </section> */}

            {/* <section>
                <div className="container">
                    <div class="services-section">
                        <div className="row">
                            <div className="col-4">
                                <div className="service-card">
                                    <figure>
                                        <img
                                            src={require("../../assets/images/services/distribution-service.jpg")}
                                            className="service-image"
                                        />
                                    </figure>
                                    <h3 className="service-title">Distribution Service</h3>
                                    <p className="service-description">
                                        Our global team of warehousing and distribution experts can
                                        help you to configure the best kit of value-added services
                                        in accordance with your needs and include them.
                                    </p>

                                    <a
                                        href="/services/distribution-service"
                                        className="learn-more"
                                    >
                                        <div>Learn More</div>
                                        <img
                                            className="arrow"
                                            src="https://cdn.prod.website-files.com/65e07261d79c218a592f2edf/65e07261d79c218a592f2f21_Link%20Arrow.svg"
                                            loading="lazy"
                                            alt="Left Arrow"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="service-card">
                                    <figure>
                                        <img
                                            src={require("../../assets/images/services/warehousing-service.jpeg")}
                                            className="service-image"
                                        />
                                    </figure>
                                    <h3 className="service-title">Warehousing Service</h3>
                                    <p className="service-description">
                                        Our strategic warehousing locations combined with best in
                                        class design tools, processes and systems ensure
                                        cost-efficient distribution solutions
                                    </p>

                                    <a
                                        href="/services/distribution-service"
                                        className="learn-more"
                                    >
                                        <div>Learn More</div>
                                        <img
                                            className="arrow"
                                            src="https://cdn.prod.website-files.com/65e07261d79c218a592f2edf/65e07261d79c218a592f2f21_Link%20Arrow.svg"
                                            loading="lazy"
                                            alt="Left Arrow"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="service-card">
                                    <figure>
                                        <img
                                            src={require("../../assets/images/services/package.jpg")}
                                            className="service-image"
                                        />
                                    </figure>
                                    <h3 className="service-title">Package</h3>
                                    <p className="service-description">
                                        Our strategic warehousing locations combined with best in
                                        class design tools, processes and systems ensure
                                        cost-efficient distribution solutions
                                    </p>

                                    <a
                                        href="/services/distribution-service"
                                        className="learn-more"
                                    >
                                        <div>Learn More</div>
                                        <img
                                            className="arrow"
                                            src="https://cdn.prod.website-files.com/65e07261d79c218a592f2edf/65e07261d79c218a592f2f21_Link%20Arrow.svg"
                                            loading="lazy"
                                            alt="Left Arrow"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="service-card">
                                    <figure>
                                        <img
                                            src={require("../../assets/images/services/land-express.jpg")}
                                            className="service-image"
                                        />
                                    </figure>
                                    <h3 className="service-title">Land Express</h3>
                                    <p className="service-description">
                                        Our non-asset based Land network provides you with
                                        flexibility, improved service and accelerated delivery.
                                    </p>

                                    <a
                                        href="/services/distribution-service"
                                        className="learn-more"
                                    >
                                        <div>Learn More</div>
                                        <img
                                            className="arrow"
                                            src="https://cdn.prod.website-files.com/65e07261d79c218a592f2edf/65e07261d79c218a592f2f21_Link%20Arrow.svg"
                                            loading="lazy"
                                            alt="Left Arrow"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="service-card">
                                    <figure>
                                        <img
                                            src={require("../../assets/images/services/distribution-service.jpg")}
                                            className="service-image"
                                        />
                                    </figure>
                                    <h3 className="service-title">Ocean Freight</h3>
                                    <p className="service-description">
                                        Customized solutions for your specific ocean freight
                                        requirement are at the heart of our services.
                                    </p>

                                    <a
                                        href="/services/distribution-service"
                                        className="learn-more"
                                    >
                                        <div>Learn More</div>
                                        <img
                                            className="arrow"
                                            src="https://cdn.prod.website-files.com/65e07261d79c218a592f2edf/65e07261d79c218a592f2f21_Link%20Arrow.svg"
                                            loading="lazy"
                                            alt="Left Arrow"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="service-card">
                                    <figure>
                                        <img
                                            src={require("../../assets/images/services/air-freight.jpg")}
                                            className="service-image"
                                        />
                                    </figure>
                                    <h3 className="service-title">Air Freight</h3>
                                    <p className="service-description">
                                        Our global team of Air Freight experts can help you to
                                        configure the best kit of value-added services in accordance
                                        with your needs and include them as part of our value
                                        proposition. Logi invest time and expertise to fully
                                        understand your business.
                                    </p>

                                    <a
                                        href="/services/distribution-service"
                                        className="learn-more"
                                    >
                                        <div>Learn More</div>
                                        <img
                                            className="arrow"
                                            src="https://cdn.prod.website-files.com/65e07261d79c218a592f2edf/65e07261d79c218a592f2f21_Link%20Arrow.svg"
                                            loading="lazy"
                                            alt="Left Arrow"
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section>
                <div className="">
                    <div className="service-list-box">

                        <div className="title-wrapper">
                            <h6 className="subtitle">SERVICE LIST</h6>
                            <h2 className="title"> The Best Process</h2>
                            <h2 className="title"> Customer</h2>
                            {/* <p className="title-description">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                eiusmod tempor <br /> incididunt ut labore et dolore magna aliqua.
                            </p> */}
                        </div>
                        <div className="service-list-process">
                            <div className="row gy-5">
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <div className="service-list">
                                        <div className="icon">  <img src={airIcon} alt='img' /> </div>
                                        <h3>Last-Mile Delivery</h3>
                                        <p className="paragraph">
                                            Fast, eco-conscious deliveries that bring your products straight to your customers' doors.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <div className="service-list">
                                        <div className="icon">  <img src={oceanIcon} alt='img' /> </div>
                                        <h3>Regional Freight</h3>
                                        <p className="paragraph">
                                            Covering short to mid-range hauls with the efficiency of electric vehicles, lowering costs and emissions.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <div className="service-list">
                                        <div className="icon">  <img src={pacakgeIcon} alt='img' /> </div>
                                        <h3>AI-Driven Logistics Optimization</h3>
                                        <p className="paragraph">
                                            Smart scheduling, route planning, and battery management to enhance operational efficiency and reduce energy consumption.
                                        </p>
                                    </div>
                                </div>
                                {/* <div className="col-lg-4 offset-2">
                                    <div className="service-list">
                                        <div className="icon">  <img src={landIcon} /> </div>
                                        <h3>Seamless Onboarding</h3>
                                        <p className="paragraph">
                                            Hassle-free onboarding and integration into I-Line’s tech-enabled logistics ecosystem.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="service-list">
                                        <div className="icon">  <img src={landIcon} /> </div>
                                        <h3>Collaborative Fleet Partnerships</h3>
                                        <p className="paragraph">
                                            Dedicated solutions to maximize fleet utilization through partnerships with I-Line’s logistics network.
                                        </p>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="">
                    <div className="service-list-box">

                        <div className="title-wrapper">
                            <h6 className="subtitle">SERVICE LIST</h6>
                            <h2 className="title"> The Best Process</h2>
                            <h2 className="title"> Fleet Operators</h2>
                            {/* <p className="title-description">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                eiusmod tempor <br /> incididunt ut labore et dolore magna aliqua.
                            </p> */}
                        </div>
                        <div className="service-list-process">
                            <div className="row gy-5">
                                {/* <div className="col-lg-4">
                                    <div className="service-list">
                                        <div className="icon">  <img src={airIcon} /> </div>
                                        <h3>Last-Mile Delivery</h3>
                                        <p className="paragraph">
                                            Fast, eco-conscious deliveries that bring your products straight to your customers' doors.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="service-list">
                                        <div className="icon">  <img src={oceanIcon} /> </div>
                                        <h3>Regional Freight</h3>
                                        <p className="paragraph">
                                            Covering short to mid-range hauls with the efficiency of electric vehicles, lowering costs and emissions.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="service-list">
                                        <div className="icon">  <img src={pacakgeIcon} /> </div>
                                        <h3>AI-Driven Logistics Optimization</h3>
                                        <p className="paragraph">
                                            Smart scheduling, route planning, and battery management to enhance operational efficiency and reduce energy consumption.
                                        </p>
                                    </div>
                                </div> */}
                                <div className="col-lg-4 offset-lg-2 col-md-6">
                                    <div className="service-list">
                                        <div className="icon">  <img src={landIcon} alt='img' /> </div>
                                        <h3>Seamless Onboarding</h3>
                                        <p className="paragraph">
                                            Hassle-free onboarding and integration into I-Line’s tech-enabled logistics ecosystem.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div className="service-list">
                                        <div className="icon">  <img src={landIcon} alt='img' /> </div>
                                        <h3>Collaborative Fleet Partnerships</h3>
                                        <p className="paragraph">
                                            Dedicated solutions to maximize fleet utilization through partnerships with I-Line’s logistics network.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='WeProvideArea'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="wpaLeft">
                                <h2>
                                    we deliver a cleaner, greener future. Start your journey with I-Line today.<br /> Wallet-Friendly. Eco-Friendly. Future-Ready.
                                </h2>
                                {/* <ul>
                                    <li><span className='circle'></span></li>
                                    <li><span className='circle'></span></li>
                                    <li><span className='circle'></span></li>
                                </ul> */}
                                <Link className='BrandBtn' to='/about' onClick={scrollToTop} >Read More</Link>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="WpaRight">
                                <img src={require('../../assets/images/img-5.jpg')} alt='img' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='ChooseUsArea'>
                <ul>
                    <li><img src={require('../../assets/images/services/service-10.jpg')} alt='img' /></li>
                    <li><img src={require('../../assets/images/services/service-11.jpg')} alt='img' /></li>
                    <li>
                        <figcaption>
                            Choose us & start your business ?
                        </figcaption>
                        <Link className='BrandOutline' to="/contact" onClick={scrollToTop}>
                            Contact us
                        </Link>
                    </li>
                </ul>
            </section>
            <Footer />

        </>
    )
}

export default Services;